export const finallyBorder = (selectValue) => {
  const borderColor = selectValue ? '#EDEDED' : '#D00000';
  return `1px solid ${borderColor}`;
};

export const finallyBorderInput = (selectValue) => {
  const borderColor = selectValue ? '#EDEDED' : '#D00000';
  return `1px solid ${borderColor}`;
};
